import { ROLES, type Role } from "@shelflist/shared";
import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface RoleSelectProps {
  id?: string;
  value: Role;
  onChange: (role: Role) => void;
  disabled?: boolean;
  "aria-label"?: string;
  className?: string;
}

export function RoleSelect({ id, value, onChange, disabled, className, ...rest }: RoleSelectProps) {
  const { t } = useTranslation();
  return (
    <Select value={value} onValueChange={(next) => onChange(next as Role)} disabled={disabled}>
      <SelectTrigger id={id} aria-label={rest["aria-label"]} className={className}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {ROLES.map((role) => (
          <SelectItem key={role} value={role}>
            {t(`roles.${role}`)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
